// extracted by mini-css-extract-plugin
export default {"root":"IconTopAdvisor_root__xsUgK"};